const constantStyle = {
  tooltipBorder: { size: '1px', color: '#E0E0E0', side: 'all' },
}

export default constantStyle
